module.exports = __webpack_public_path__ + "assets/normal/images/loading.0f29f2bf.png";